
import React from "react";
import { cn } from "@/lib/utils";
import { Progress } from "@/components/ui/progress";

export type Step = {
  number: number;
  title: string;
  description?: string;
};

interface StepProgressProps {
  steps: Step[];
  currentStep: number;
  className?: string;
}

export function StepProgress({ steps, currentStep, className }: StepProgressProps) {
  // Calculate progress percentage
  const progressPercentage = Math.round(((currentStep - 1) / (steps.length - 1)) * 100);

  return (
    <div className={cn("w-full space-y-4", className)}>
      <Progress value={progressPercentage} className="h-2 bg-white/20" />
      
      <div className="flex justify-between">
        {steps.map((step) => {
          const isActive = step.number === currentStep;
          const isCompleted = step.number < currentStep;
          
          return (
            <div 
              key={step.number} 
              className={cn(
                "flex flex-col items-center space-y-1",
                isActive ? "text-white" : "text-white/50"
              )}
            >
              <div 
                className={cn(
                  "flex h-8 w-8 items-center justify-center rounded-full border", 
                  isActive 
                    ? "border-white bg-white/20 text-white" 
                    : isCompleted 
                      ? "border-white/50 bg-white/50 text-black" 
                      : "border-white/30 bg-transparent text-white/30"
                )}
              >
                {step.number}
              </div>
              <span className="text-sm font-medium">{step.title}</span>
              {step.description && (
                <span className="text-xs text-white/60">{step.description}</span>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
}
